import Model from './Model'

export default class BankTransfer extends Model {
  // Set the resource route of the model
  resource() {
    return 'bank-transfers'
  }
}
